import { queryOptions, useQuery } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type FastboundCsvRowDiff = {
    rowNumber: number
    storeId?: string | null
    fflNumber: string
    invoiceId: string
    priceNickname: string
    reason: string
    rawValues: string[]
}

export const getFastboundDiff = async (): Promise<FastboundCsvRowDiff[]> => {
    try {
        return await api.get('/v2/subscriptions/fastbound/diff')
    } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
            return []
        }
        throw error
    }
}

export const getFastboundDiffQueryOptions = () => {
    return queryOptions({
        queryKey: ['reports', 'fastbound-diff'],
        queryFn: () => getFastboundDiff(),
    })
}

type UseFastboundDiffOptions = {
    queryConfig?: QueryConfig<typeof getFastboundDiff>
}

export const useFastboundDiff = ({ queryConfig }: UseFastboundDiffOptions = {}) => {
    return useQuery({
        ...getFastboundDiffQueryOptions(),
        ...queryConfig,
    })
}


